<template>
  <button
    @click="selectMethod()"
    class="btn btn-method"
    :class="method"
    data-test="payment-method-button"
  >
    <span
      ><img
        :src="getMethodLogo()"
        :alt="'logo ' + $t(`paymentselect.${method}`)"
    /></span>
    {{ $t(`paymentselect.${method}`) }}
  </button>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");
export default {
  name: "buttonMethod",
  props: ["method"],
  computed: {
    ...paymentNS.mapGetters(["page", "pageDetails"]),
  },
  methods: {
    ...paymentNS.mapActions(["updateState"]),
    ...paymentNS.mapMutations(["setLoading"]),
    selectMethod() {
      let params = {
        path: "select-payment-method",
        data: {
          paymentMethod: this.method,
        },
      };
      this.updateState(params);
    },
    getMethodLogo() {
      return require(`../assets/${this.method}.svg`);
    },
  },
};
</script>
